import type { KorintModulesConfig } from '../KorintConfig';
import { useKorintConfig } from './useKorintConfig';

export const useHasKorintModuleConfig = <TConfigKey extends keyof KorintModulesConfig>(
  configKey: TConfigKey,
) => {
  const { korintConfig } = useKorintConfig();

  return Boolean(korintConfig.modulesConfig?.[configKey]);
};

export const useKorintModuleConfig = <TConfigKey extends keyof KorintModulesConfig>(
  configKey: TConfigKey,
): NonNullable<KorintModulesConfig[TConfigKey]> => {
  const { korintConfig } = useKorintConfig();

  const config = korintConfig.modulesConfig?.[configKey];

  if (!config) {
    throw new Error(`[${configKey}] Korint module config not found`);
  }

  return config;
};
